import React, { useState } from "react";
import clsx from "clsx";
import { connect } from "react-redux";
import { Dropdown } from "react-bootstrap";
import { metronic, toAbsoluteUrl } from "../../../_metronic";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";

const languages = [
  {
    lang: "en",
    name: "English",
    flag: toAbsoluteUrl("/media/flags/260-united-kingdom.svg"),
  },
  {
    lang: "zh",
    name: "Mandarin",
    flag: toAbsoluteUrl("/media/flags/034-china.svg"),
  },
  {
    lang: "es",
    name: "Spanish",
    flag: toAbsoluteUrl("/media/flags/128-spain.svg"),
  },
];

const LanguageSelector = (props) => {
  const { lang, iconType, setLanguage } = props;
  const currentLanguage = languages.find((x) => x.lang === lang);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <div className="flex justify-center items-center h-full cursor-pointer py-0 px-3">
        <button
          className={clsx("kt-header__topbar-icon", {
            "kt-header__topbar-icon--brand": iconType === "brand",
          })}
          onClick={() => setIsOpen((state) => !state)}
        >
          <img
            style={{ width: 30, borderRadius: "6px" }}
            src={currentLanguage.flag}
            alt={currentLanguage.name}
          />
        </button>
      </div>
      <div className={`language-popup-mobile-menu ${isOpen ? "active" : ""}`}>
        <div className="language-inner rounded">
          <div className="absolute right-2 top-2">
            <div className="h-7 w-7 rounded-full flex items-center justify-center bg-gray-600 text-white">
              <button
                className="close-button"
                onClick={() => setIsOpen((state) => !state)}
              >
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
          </div>
          <ul className="kt-nav">
            {languages.map((language) => (
              <li
                key={language.lang}
                className={clsx("kt-nav__item", {
                  "kt-nav__item--active":
                    language.lang === currentLanguage.lang,
                })}
              >
                <span
                  onClick={() => {
                    setLanguage(language.lang);
                    setIsOpen(false);
                    setTimeout(() => {
                      window.location.reload();
                    }, 100);
                  }}
                  className={clsx("kt-nav__link", {
                    "kt-nav__link--active":
                      language.lang === currentLanguage.lang,
                  })}
                >
                  <span className="kt-nav__link-icon">
                    <img
                      style={{
                        width: "80%",
                        marginRight: 10,
                        borderRadius: "8px",
                      }}
                      src={language.flag}
                      alt={language.name}
                    />
                  </span>
                  <span className="kt-nav__link-text">{language.name}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

class LanguageSelectorr extends React.Component {
  render() {
    const { lang, iconType, setLanguage } = this.props;
    const currentLanguage = languages.find((x) => x.lang === lang);

    return (
      <>
        <Dropdown
          className="flex justify-center items-center h-full cursor-pointer py-0 px-3"
          drop="down"
        >
          <Dropdown.Toggle
            as={HeaderDropdownToggle}
            id="dropdown-toggle-my-cart"
          >
            <div
              className={clsx("kt-header__topbar-icon", {
                "kt-header__topbar-icon--brand": iconType === "brand",
              })}
            >
              <img
                style={{ width: 30, borderRadius: "6px" }}
                src={currentLanguage.flag}
                alt={currentLanguage.name}
              />
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu
            className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround"
            style={{ borderRadius: "10px", minWidth: 150 }}
          >
            <ul className="kt-nav">
              {languages.map((language) => (
                <li
                  key={language.lang}
                  className={clsx("kt-nav__item", {
                    "kt-nav__item--active":
                      language.lang === currentLanguage.lang,
                  })}
                >
                  <span
                    onClick={() => {
                      setLanguage(language.lang);
                      this.setState({ open: false });
                      setTimeout(() => {
                        window.location.reload();
                      }, 100);
                    }}
                    className={clsx("kt-nav__link", {
                      "kt-nav__link--active":
                        language.lang === currentLanguage.lang,
                    })}
                  >
                    <span className="kt-nav__link-icon">
                      <img
                        style={{
                          width: "80%",
                          marginRight: 10,
                          borderRadius: "8px",
                        }}
                        src={language.flag}
                        alt={language.name}
                      />
                    </span>
                    <span className="kt-nav__link-text">{language.name}</span>
                  </span>
                </li>
              ))}
            </ul>
          </Dropdown.Menu>
        </Dropdown>
      </>
    );
  }
}

const mapStateToProps = ({ i18n }) => ({ lang: i18n.lang });

export default connect(
  mapStateToProps,
  metronic.i18n.actions
)(LanguageSelector);
